var sha256 = require('js-sha256');
import { createApp } from 'vue';

export default {
    name : 'product-terms',

        init()
        {
            if (document.getElementById("products-app")) {
                this.initProducts();
            }
    },

    initProducts()
    {
        createApp({

            data() {
                return {
                    termId : null,
                    search : '',
                    page : 0,
                    query : '',
                    showFilters : true,
                    terms : null,
                    products : [],
                    filters : [],
                    activeFilters : [],
                    ignoreFilters : [],
                    results : null,
                    xhrActive : false,
                    chatStyle : null,
                    toggledFilterOptions : new Set(),
                }
            },

            created: function () {
                // console.log('ready!!');
                const appEl = document.getElementById("products-app");
                this.termId = appEl.dataset?.term;
                this.terms = appEl.dataset?.terms;
                // this.getItems();
                this.filters = typeof appEl.dataset.filters !== 'undefined' ?
                    JSON.parse(appEl.dataset.filters) :
                    [];

                this.query = this.getSearchQuery();

                this.maybeSetInitResults();

                this.maybeHideFilters();
                this.search = this.getSearchArg();
                // console.log('filters');
                // console.log(this.filters);
                window.onresize = this.maybeHideFilters;
            },

            computed:
            {
                filterPanelClass()
                {
                    return this.showFilters ? ' active-filters ' : '';
                },
            },

            methods :
            {
                queryMatch(sku)
                {
                    return sku === this.query ? ' is-match ' : '';
                },

                getSearchQuery()
                {
                    const queryString = window.location.search;
                    const urlParams = new URLSearchParams(queryString);

                    return urlParams.get('s');
                },

                setActiveFilters()
                {
                    const queryString = window.location.search;
                    const urlParams = new URLSearchParams(queryString);

                    this.activeFilters = [];
                    for (const key of urlParams.keys()) {
                        if (key !== 's' && key !== 'page') {
                            this.activeFilters.push(key);
                        }
                    }
                },

                maybeSetInitResults()
                {
                    if (typeof initResults === 'object') {
                        this.setResultsToData(initResults);
                    }
                },

                addToCart(mmId, sku, qty)
                {
                    const t = Date.now();

                    const data = {
                        action: 'add_to_cart',
                        t : t,
                        mm_id: mmId,
                        sku : sku,
                        csfr : sha256(t+sku)
                    };

                    // console.log(xhrUrl);
                    // console.log(data);

                    const config = {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        }
                    };

                    // axios.post('/wp-json/norclean/v1/add-to-cart?lad=aksdfj&lksdjf=kljdf', data, config)
                    axios.post(xhrUrl, data, config)
                        .then(this.addToCart__callback)
                        .catch(function (error) {
                            console.log(error);
                        });
                },

                addToCart__callback(response)
                {
                    // console.log('addToCart__callback');
                    // console.log(response.data);
                    if (typeof response === 'object' && response.status === 200 && typeof response.data.cart_item_key === 'string') {
                        // console.log('product-'+response.data.mm_id);
                        document.getElementById('product-'+response.data.mm_id).classList.add('added');
                    }
                },

                maybeHideFilters()
                {
                    if (window.innerWidth < 768) {
                        this.showFilters = false;
                    }
                },

                isActiveTerm(term)
                {
                    return term.id == this.termId ? 'active' : '';
                },

                isSubTerms(filter)
                {
                    return (filter.type === 'terms' && filter.options.length);
                },

                isFacet(filter)
                {
                    return (filter.type === 'checkbox' || filter.type === 'select');
                },

                isFacetAvailable(filter)
                {
                    return (typeof this.results.facets[filter.id] === 'object');
                },

                isFacetOptionAvailable(oValue, filter)
                {
                    return typeof filter.facets[oValue] !== 'undefined' ? true : false;
                },

                isSelected(oValue, filter)
                {
                    return filter.selected.includes(oValue);
                },

                maybeIgnoreFilter(filter)
                {
                    return this.isFacet(filter) && ! this.isFacetAvailable(filter);
                },

                getOptionCssClass(option, filter)
                {
                    if (typeof option.label === 'undefined' || typeof option.value === 'undefined') {
                        return false;
                    }

                    const optionId = filter.id+'-'+option.value;
                    const countItems = option.facet_count;

                    const isNoOption = (option.label === '---' ||  option.value.length === 0);

                    const isSlimFilter = (typeof filter.slim !== 'undefined' && filter.slim == 1 && countItems === 0);

                    const hasNoOptionsAtAll = (countItems === 0 && this.activeFilters.length === 0);

                    if (option.value === "Contractor King") {
                        console.log(option);
                    }

                    if (isNoOption || isSlimFilter || hasNoOptionsAtAll || option.hide_on_init) {
                        return 'is-hidden';
                    } else {
                        return 'is-visible';
                    }
                },

                toggleFilterOptions(filter)
                {
                    if (! this.toggledFilterOptions.has(filter.id)) {
                        this.toggledFilterOptions.add(filter.id);
                    } else {
                        this.toggledFilterOptions.delete(filter.id);
                    }
                },

                showAllFilterOptions(filter)
                {
                    return this.toggledFilterOptions.has(filter.id) ?
                    'yes' : 'no';
                },

                filterChanged(event, page=0)
                {
                    this.page = page;
                    const queryString = this.getQueryString();
                    const url = xhrUrl + queryString;

                    if (queryString) {
                        window.history.pushState('page', 'Norclean', queryString);
                    }

                    this.getItems(queryString);
                },

                getSearchArg()
                {
                    const params = new URLSearchParams(window.location.search);

                    return params.get('s');
                },

                getQueryString(page=null)
                {
                    const checkboxes = document.querySelectorAll('.attr-filter__checkbox:checked');
                    const queryArgs = {};
                    checkboxes.forEach((i) => {
                        if (typeof queryArgs[i.dataset.attr] === 'undefined') {
                            queryArgs[i.dataset.attr] = [];
                        }
                        queryArgs[i.dataset.attr].push(i.value);
                    })

                    // handle numeric search
                    const numeric = document.querySelectorAll('.attr-filter__number');
                    numeric.forEach((i) => {
                        if (typeof queryArgs[i.dataset.attr] === 'undefined') {
                            queryArgs[i.dataset.attr] = [];
                        }
                        queryArgs[i.dataset.attr].push(i.value);
                    })

                    queryArgs['page'] = page ? page : this.page;

                    queryArgs['s'] = this.search ? this.search : '';

                    let queryString = '?';
                    for (var i in queryArgs) {
                        if (queryArgs[i]) {
                            queryString += i + "=" + queryArgs[i]+"&";
                        }
                    }

                    return queryString;
                },

                getFacetCount(oValue, filter)
                {
                    return typeof filter.facets[oValue] === 'number' ? filter.facets[oValue]  : 0;
                },

                getImageUrl(item)
                {
                    if (typeof item.image === 'string' && item.image.length) {
                        return this.filterImgixUrl(item.image)+"&w=360&h=auto&auto=format";
                    } else {
                        return '/app/themes/norfront/dist/images/placeholder.jpg';
                    }
                },

                filterImgixUrl(url)
                {
                    // replace imgix with new cdn (soon deprecated)
                    url = url.replace('tibe.imgix.net', 'cdn.tibe.app/image/norclean');
                    // replace master url (cdn.tibe.app/image/master/) with client "norclean"
                    url = url.replace('/master/', '/norclean/', url);

                    return url;
                },

                setPage(n, event)
                {
                    event.preventDefault();
                    this.filterChanged(event, n);
                },

                getPaginationLink(n)
                {
                    return this.getQueryString(n)
                },

                getItems()
                {
                    this.xhrActive = true;
                    const queryArgs = {
                        action : 'get_products',
                        termId : this.termId,
                        terms : this.terms,  // facet parameter
                        page : this.page
                    };

                    // console.log(queryArgs);

                    let queryString = '';
                    for (var i in queryArgs) {
                        queryString += i + "=" + queryArgs[i]+"&";
                    }
                    const url = '/wp-json/norclean/v1/products/search' +
                        "?" + queryString + document.location.search.replace('?', '');

                    axios.get(url).then(this.getItems__callback);
                },

                getItems__callback(response)
                {
                    // console.log('getItems__callback');
                    if (typeof response.data === 'object' && response.status === 200) {
                        this.setResultsToData(response.data);
                        this.scrollToTop();
                    } else {
                        this.results = null;
                        this.products = null;
                    }

                    this.xhrActive = false;

                    this.setActiveFilters();
                },

                scrollToTop()
                {
                    // scroll to top
                    const container = document.getElementById('products-app');

                    if (container) {
                        container.scrollIntoView({
                            behavior: "smooth",
                            inline: "nearest"
                        });
                    }
                },

                setResultsToData(results)
                {
                    this.results = results;
                    this.products = results.hits;

                    // add facets info to filter
                    if (typeof results.facets === 'object') {
                        for (let fieldId in results.facets) {
                            this.filters.forEach((field) => {
                                let optionsWithCount = 0;

                                if (field.id == fieldId) {
                                    // set facet info to field object
                                    field.facets = results.facets[fieldId];
                                    // show toggle button if a filter has more than 8 options
                                    field.show_more_or_less_button = (field.options.length >= 8);
                                    // set facet count to the options
                                    field.options.forEach((o) => {
                                        // set to 0 by default
                                        o.facet_count = 0;
                                        // set to 1 be default
                                        o.hide_on_init = 1;
                                        // if the facet value is defined & number
                                        if (typeof field.facets[o.value] === 'number') {
                                            // set facet count
                                            o.facet_count = field.facets[o.value];
                                            // hide this if there are already 8 or more options
                                            o.hide_on_init = (optionsWithCount >= 8) ? 1 : 0;
                                            // increase counter
                                            optionsWithCount += 1;
                                        } else {
                                            // show toggle button if there are options facet count = 0
                                            field.show_more_or_less_button = true;
                                        }

                                    });
                                }
                            })
                        }
                    }
                },

                toggleFilter(filterId)
                {
                    const el = document.querySelector('.attr-filter[data-filter_id="'+filterId+'"]');
                    if (el) {
                        el.classList.toggle('expanded');
                    }
                },

                toggleFilterPanel()
                {
                    this.showFilters = ! this.showFilters;

                    const chat = document.querySelector('iframe[data-hj-allow-iframe]');

                    if (chat && this.chatStyle === null) {
                        this.chatStyle = chat.getAttribute('style');
                    }

                    if (window.innerWidth <= 480) {
                        if (this.showFilters ) {
                            chat.style = 'left: -9999px ! important';
                        } else {
                            chat.style = this.chatStyle;
                        }
                    }
                },

            }

        }).mount('#products-app'); // end of vue
    }
}